import { render, staticRenderFns } from "./EnergyGraph2D.vue?vue&type=template&id=39ed7334&"
import script from "./EnergyGraph2D.vue?vue&type=script&lang=js&"
export * from "./EnergyGraph2D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports